import React from 'react';
import { elements, actions } from '@ecosystem/newron-design-system';
import { Market, TimeFrameOption } from '../types';

const { Icon } = elements;
const { Button } = actions;

type Props = {
  option: TimeFrameOption;
  markets: Market[];
  onBack: () => void;
  onSelect: (option: TimeFrameOption, removeAffectedMarkets: boolean) => void;
};
function IncompletePeriod({ option, markets, onBack, onSelect }: Props) {
  const { endSequence, periodicity, label } = option;
  const affectedMarkets = markets.filter(m =>
    m.periods.find(p => p.periodicity === periodicity && p.sequence < endSequence)
  );

  return (
    <div className="py-3 px-4 overflow-y-auto overscroll-contain">
      <button onClick={onBack} className="flex items-center text-sm text-brand py-1">
        <Icon size="sm" color="brand">
          <Icon.icons.ChevronLeft />
        </Icon>
        back
      </button>
      <div className="font-bold text-heading flex gap-2 mt-2 mb-2">
        <Icon color="info">
          <Icon.icons.Info />
        </Icon>
        <span>Data not published</span>
      </div>
      <p className="text-sm">
        <b>{label}</b> data is not yet available for <b>{affectedMarkets.length}</b> of your <b>{markets.length}</b>{' '}
        selected markets.
      </p>
      <div className="my-4">
        {affectedMarkets.slice(0, 5).map(m => (
          <div className="text-xs font-bold" key={m.value}>
            {m.label}
          </div>
        ))}
        {affectedMarkets.length > 5 && (
          <span className="text-lighter text-xs">+ {affectedMarkets.length - 5} more</span>
        )}
      </div>
      <p className="text-sm mt-4">Do you want to remove the affected markets before moving to {label}?</p>
      <div className="relative px-2 pt-4 flex flex-column items-stretch gap-2">
        <div className="relative flex h-10">
          <Button onClick={() => onSelect(option, true)} stretch>
            Yes, remove them
          </Button>
        </div>
        <div className="relative flex h-10">
          <Button mode="secondary" onClick={() => onSelect(option, false)} stretch>
            No, continue anyway
          </Button>
        </div>
      </div>
    </div>
  );
}

export { IncompletePeriod };
